module.exports = __webpack_public_path__ + "static/img/26556260.382617f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/26556260.jpg
// module id = mX95
// module chunks = 0